$(function() {
	// -------------------------------------------
	// 業者一覧(地図表示)
	// -------------------------------------------
	const $searchResultMapForm = $('form#searchResultMapForm:eq(0)');
	$searchResultMapForm.each(function() {
		const ENABLED_ZOOM_MIN = parseInt($searchResultMapForm.attr('data-enabled-zoom-min'));
		const ZOOM_DEFALT_CITY = parseInt($searchResultMapForm.attr('data-zoom-default-city'));
		const ZOOM_DEFALT_STATION = parseInt($searchResultMapForm.attr('data-zoom-default-station'));
		Nifty.WallPaint.JsRender.isSearchMap = true;

		const searchForm = Nifty.WallPaint.SearchForm.create($searchResultMapForm);
		Nifty.WallPaint.Pc.Function.setSearchConditionPlacesHtml(searchForm);

		const $resultMapCanvas = $('#resultMapCanvas');
		if (typeof google != 'undefined' && typeof google.maps != 'undefined' && $resultMapCanvas.length > 0) {
			const $resultMapListArea = $('#resultMapListArea');
			const $resultMapListLoading = $('#resultMapListLoading');
			const $resultMapListScroll = $('#resultMapListScroll');
			const $resultMapErrorMsg = $('[data-result-map-error-msg]');
			const $resultMapListOpenTrigger = $('[data-map-action-open="map-right-menu"]:eq(0)');
			const $resultMapListCloseTrigger = $('[data-map-action-close="map-right-menu"]:eq(0)');
			const $inputLatitude = $searchResultMapForm.find('input[data-latitude]');
			const $inputLongitude = $searchResultMapForm.find('input[data-longitude]');
			const $inputZoom = $searchResultMapForm.find('input[data-zoom]');

			const latLng = new google.maps.LatLng($inputLatitude.val(), $inputLongitude.val());
			const map = new google.maps.Map($resultMapCanvas[0], {
				center: latLng
				,mapTypeId: google.maps.MapTypeId.ROADMAP
				,disableDefaultUI: true
				,zoomControl: true
				,zoom: parseInt($inputZoom.val())
			});

			// 地図検索: 地図移動時
			let isEnableIdleEvent = true;
			let isInitialIdle = true;
			const $resultMapReSearchBtn = $('#resultMapReSearchBtn');
			// 地図初回読み込み時とドラッグやズーム時に発火
			google.maps.event.addListener(map, 'idle', function() {
				if (!isEnableIdleEvent) {
					return;
				}
				setMapCenter();
				if (map.getZoom() < ENABLED_ZOOM_MIN) {
					setResultMapErrorMsg(true);
					$resultMapReSearchBtn.hide();
				} else {
					setResultMapErrorMsg(false);
					if(!isInitialIdle) {
						$resultMapReSearchBtn.fadeIn(300);
					}
				}
				isInitialIdle = false;
			});
			$resultMapReSearchBtn.click(() => {
				// 地図移動後の再検索時はPV送信しない
				getResultMapCount(false);
			});

			// 地図検索: 非同期検索時のURL更新
			Nifty.WallPaint.History.setPopstate();
			let prevUrl = '';
			const getCurrentUrl = function() {
				return Nifty.Utils.Url.addParam($searchResultMapForm.attr('action'), searchForm.makeResultConditionQuery());
			};
			const pushHistoryState = function(url) {
				if (url != prevUrl) {
					// 補足: 地図を移動する度に履歴をpushしてしまうと、たくさん移動した後にブラウザバックで地図からなかなか抜け出せなくなるため、アドレスバーのURLを書き換えるだけにする
					Nifty.Utils.History.replaceCurrentUrl(url);
					prevUrl = url;
				}
			};

			// 地図検索: マーカー追加/削除
			let isMarkerActive = false;
			let currentMarkerId = '';
			let markerObjs = {};
			let markerData = {};
			const markers = new google.maps.MVCArray();
			const setMarkerIconLabel = function(marker, data, isActive) {
				if (marker && data) {
					Nifty.WallPaint.Map.setMarkerIconLabel(marker, isActive, String(data.count));
				}
			};
			const addMarker = function(id, data) {
				const marker = new google.maps.Marker({
					position: new google.maps.LatLng(data.lat, data.lng)
				});
				markerObjs[id] = marker;
				markerData[id] = data;
				setMarkerIconLabel(marker, data, (isMarkerActive && id == currentMarkerId));

				// 地図検索: マーカーclick
				google.maps.event.addListener(marker, 'click', function(e) {
					// 中心地パラメータ設定
					setMapCenter();

					setMarkerIconLabel(markerObjs[currentMarkerId], markerData[currentMarkerId], false);
					isMarkerActive = false;
					const isResultListOpened = $resultMapListCloseTrigger.hasClass('is-active');
					if (isResultListOpened) {
						// 業者リスト表示中にアクティブなマーカーをクリック時、業者リストを閉じて終了
						if (currentMarkerId == id) {
							$resultMapListCloseTrigger.trigger('click');
							return;
						}
					}

					setMarkerIconLabel(marker, data, true);
					isMarkerActive = true;
					if (!isResultListOpened) {
						$resultMapListOpenTrigger.trigger('click');
					}
					if (currentMarkerId != id) {
						currentMarkerId = id;
						getResultMapList(id);
					}
				}) ;
				marker.setMap(map);
				markers.push(marker);
			};
			const removeMarker = function() {
				markerObjs = {};
				markerData = {};
				markers.forEach(function(marker, idx) {
					marker.setMap(null);
				});
			};

			// 地図検索: 中心設定
			const setMapCenter = function($item) {
				let latitude = map.getCenter().lat();
				let longitude = map.getCenter().lng();
				let zoom = map.getZoom();
				if ($item) {
					// 駅、市区町村選択時
					latitude = $item.attr('data-latitude');
					longitude = $item.attr('data-longitude');
					zoom = ENABLED_ZOOM_MIN;
					const type = $item.attr('data-type');
					if (type == 'city') {
						zoom = ZOOM_DEFALT_CITY;
					} else if (type == 'station') {
						zoom = ZOOM_DEFALT_STATION;
					}

					isEnableIdleEvent = false;
					map.setCenter(new google.maps.LatLng(latitude, longitude));
					map.setZoom(zoom);
					setTimeout(function() {
						// 中心地設定完了後
						isEnableIdleEvent = true;
					}, 1000);
				}
				$inputLatitude.val(latitude);
				$inputLongitude.val(longitude);
				$inputZoom.val(zoom);
			};
			const setMapAreasCenter = function($item) {
				setMapCenter($item);
				$resultMapListCloseTrigger.trigger('click');
				$searchResultMapForm.submit();
			};

			// 地図検索: 件数取得
			const getResultMapCount = function(isSendPageView, hideRightMenuIfNoMarker) {
				Nifty.WallPaint.Pc.Function.setShowLoading(true);
				searchForm.getResultMapCount(map, {
					success: function(res) {
						// マーカー更新
						removeMarker();
						for (let id in res.data) {
							addMarker(id, res.data[id]);
						}

						// エラーメッセージ表示
						if (res.error) {
							$resultMapErrorMsg.removeClass('is-hidden');
						} else {
							$resultMapErrorMsg.addClass('is-hidden');
						}

						if (hideRightMenuIfNoMarker && !markerObjs[currentMarkerId]) {
							// 表示中の業者リストに該当するマーカーが無い場合、業者リストを閉じる
							$resultMapListCloseTrigger.trigger('click');
						}

						const url = getCurrentUrl();
						pushHistoryState(url);
						if (isSendPageView) {
							Nifty.WallPaint.Tracking.sendPageView(url);
						}
						$resultMapReSearchBtn.fadeOut(300);
					}
					,error: function() {
					}
					,complete: function() {
						Nifty.WallPaint.Pc.Function.setShowLoading(false);
					}
				});
			};
			// ページ読み込み時に2重でPV送信しない
			getResultMapCount(false);

			// 地図検索: 広域エラーメッセージ表示
			const setResultMapErrorMsg = function(isShow) {
				if (isShow) {
					$resultMapErrorMsg.removeClass('is-hidden');
				} else {
					$resultMapErrorMsg.addClass('is-hidden');
				}
			};

			// 地図検索: 業者リスト取得
			const getResultMapListCallback = function(res) {
				$resultMapListArea.html(res);
			}
			const getResultMapList = function(latLng) {
				$resultMapListArea.addClass('is-hidden');
				$resultMapListLoading.removeClass('is-hidden');
				Nifty.WallPaint.Pc.Function.setShowLoading(true);

				searchForm.getResultMapList(latLng, {
					success: function(res) {
						getResultMapListCallback(res);
					}
					,error: function() {
					}
					,complete: function() {
						$resultMapListLoading.addClass('is-hidden');
						$resultMapListArea.removeClass('is-hidden');
						Nifty.WallPaint.Pc.Function.setShowLoading(false);
					}
				});
			};
			// 地図検索: 業者リスト取得(ページング)
			const getResultMapListPaging = function(url) {
				Nifty.WallPaint.Pc.Function.setShowLoading(true);
				$resultMapListScroll.animate({ scrollTop: 0 }, 'fast');

				searchForm.getResultMapList(null, {
					url: url
					,success: function(res) {
						getResultMapListCallback(res);
					}
					,error: function() {
					}
					,complete: function() {
						Nifty.WallPaint.Pc.Function.setShowLoading(false);
					}
				});
			};
			// 地図検索: 業者リスト更新(業者リスト表示中に条件変更時などに、件数だけでなく業者リストも更新する)
			const updateResultMapListIfActive = function() {
				if (isMarkerActive) {
					$resultMapListOpenTrigger.trigger('click');
					getResultMapList(currentMarkerId);
				} else {
					// 次回業者リスト表示時に再取得させるため、現在ID初期化
					currentMarkerId = '';
				}
			};
			// 地図検索: 業者リスト再表示(条件変更などのポップアップを表示すると業者リストが勝手に閉じるので、再表示させる)
			const showResultMapListIfActive = function() {
				if (isMarkerActive) {
					$resultMapListOpenTrigger.trigger('click');
				}
			};

			// 地図検索: 業者リストページングリンクclick
			$(document).on('click', 'a[data-paging-link]', function(e) {
				e.preventDefault();
				getResultMapListPaging($(this).attr('href'));
			});

			// 地図検索: 業者リスト開閉
			$resultMapListOpenTrigger.on('click', function(e) {
				$('.map-widget-msg').addClass('is-menu-opened');
			});
			$resultMapListCloseTrigger.on('click', function(e) {
				$('.map-widget-msg').removeClass('is-menu-opened');
				if (isMarkerActive) {
					setMarkerIconLabel(markerObjs[currentMarkerId], markerData[currentMarkerId], false);
					isMarkerActive = false;
				}
			});

			// 地図検索: フォームsubmit
			$searchResultMapForm.on('submit', function(e) {
				e.preventDefault();
				getResultMapCount(true);
			});

			// 地図検索: 検索条件変更(左メニュー)
			$(document).on('change', '[data-search-result-change-section] input,[data-search-result-change-section] select', function() {
				updateResultMapListIfActive();
				$searchResultMapForm.submit();
			});

			// 地図検索: 「検索結果に反映」ボタンclick
			$searchResultMapForm.on('click', 'button[data-submit-button]', function() {
				updateResultMapListIfActive();
				$searchResultMapForm.submit();
			});

			// 地図検索: 条件変更などのポップアップ閉じる
			$searchResultMapForm.on('click', '[data-micromodal-close]', function() {
				showResultMapListIfActive();
			});

			// 地図検索: 該当リンクのチェックボックスのみチェック
			const checkOnlyThisLinkItem = function($link) {
				const $checkbox = $link.closest('li').find('input[type="checkbox"]');
				searchForm.checkThisInputOnly($checkbox);
				return $checkbox;
			};
			// 地図検索: エリア選択チェックボックスリンク
			$searchResultMapForm.on('click', 'a[data-submit-area-checkbox-link]', function(e) {
				e.preventDefault();

				setMapAreasCenter(checkOnlyThisLinkItem($(this)));
				$('[data-micromodal-close="modal-change-conditions"]:eq(0)').trigger('click');
			});
			// 地図検索: 路線→駅選択チェックボックスリンク
			$searchResultMapForm.on('click', 'a[data-move-to-station-checkbox-link]', function(e) {
				e.preventDefault();

				checkOnlyThisLinkItem($(this));
				// チェックした路線の駅を絞り込むボタンの活性化
				Nifty.WallPaint.Pc.Animation.initFormLock();
				$('[data-multitab-control="station"]:eq(0)').trigger('click');
			});

			// 地図検索: 路線選択数チェック
			$searchResultMapForm.on('change', '[data-multitab-content="line"] input[type="checkbox"]', function() {
				searchForm.checkLineCondSelect($(this));
			});
			// 地図検索: チェックした路線の駅を絞り込む
			$searchResultMapForm.on('click', 'button[data-move-to-station-button]', function() {
				Nifty.WallPaint.Pc.Function.setSearchConditionStationHtml();
			});

			// 地図検索: 条件パラメータ引継ぎリンク
			$(document).on('click', 'a[data-extends-cond-param]', function(e) {
				e.preventDefault();
				const path = $(this).attr('data-search-map-path');
				location.href = searchForm.makeExtendsCondParamLinkMapUrl(path ? path : $(this).attr('href'));
			});

			// 地図検索: カンタン検索
			const $mapEasySearchSection = $('[data-map-easy-search-section]');
			$mapEasySearchSection.each(function() {
				const $input = $(this).find('input[data-map-easy-search-input]');
				const $clear = $(this).find('[data-map-easy-search-clear]');
				const $suggest = $(this).find('[data-template="map-easy-search-suggest"]');
				const $suggestBase = $(this).find('[data-template-base="map-easy-search-suggest"]');
				// Internet Explorer, Microsoft Edgeで:placeholder-shownが効かない為、代替classを付与
				const classIsPlaceholderShown = 'is-placeholder-shown';

				searchForm.setEasySearchEvents($input, null, function() {
					// カンタン検索: 候補表示
					$input.on('keyup', function() {
						const value = $(this).val();
						const placeholder = $(this).attr('placeholder');
						const data = {
							suggests: []
						};
						if (value) {
							const hits = searchForm.getMapEasySearchResult(value);
							searchForm.addEasySearchSuggestData(data.suggests, '駅', hits.station, 'station');
							searchForm.addEasySearchSuggestData(data.suggests, '市区町村', hits.city, 'city');
							if (data.suggests.length <= 0) {
								searchForm.addEasySearchSuggestData(data.suggests, '候補が見つかりません。');
							}
							$(this).removeClass(classIsPlaceholderShown);
						} else {
							searchForm.addEasySearchSuggestData(data.suggests, placeholder + 'を入力してください。');
							$(this).addClass(classIsPlaceholderShown);
						}
						$suggest.html(Nifty.WallPaint.JsRender.render($suggestBase, data));
					});
					// 初期設定
					$input.trigger('keyup');

					// カンタン検索: 候補選択(左クリック時のみ)
					$suggest.on('mousedown', 'a', function(e) {
						if (e.button === undefined || e.button === 0) {
							e.preventDefault();
							// ブラウザによってはフォーカスが残る為、明示的に解除
							$input.val($(this).attr('data-name')).trigger('keyup').blur();
							$suggest.removeClass('is-active');
							setMapAreasCenter($(this));
						}
					});

					// カンタン検索: 入力クリア
					$clear.on('click', function() {
						$input.val('').trigger('keyup');
					});

					// カンタン検索: フォーカスON/OFF
					$input.on('focus', function() {
						$suggest.addClass('is-active');
					});
					$input.on('blur', function() {
						setTimeout(function() {
							// 候補選択より後に動作させる
							$suggest.removeClass('is-active');
						}, 100);
					});
				});
			});
		}
	});
	// ここまで地図検索 --------------------------
});
